import { DownloadApps } from 'src/components/DownloadApps';
import { URLS } from 'src/utils/urls/urls';

export const ConnectOfferDownloadAppsPage = () => (
  <DownloadApps to={URLS.STORE_CONNECT_OFFER_SETUP_COMPLETE} />
);
